import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faBook, faUsers, faLayerGroup, faArrowRight } from '@fortawesome/free-solid-svg-icons';

class ConfiguracionCursos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datos: {
                cursos: [],
                materias: [],
                contenidos: [],
                estudiantes: [],
                grupos: []
            },
            seleccion: {
                curso: '',
                materia: '',
                grupo: ''
            },
            asignacion: {
                materia_id: '',
                contenido_id: '',
                estudiante_id: ''
            },
            relaciones: {
                materias_curso: [],
                contenidos_materia: [],
                estudiantes_grupo: []
            },
            tab: 'cursos' // cursos, materias, matriculas
        };
    }

    componentDidMount() {
        this.cargarDatos();
    }

    cargarDatos = () => {
        authAxios.get("configuracion-educativa/datos")
            .then(res => this.setState({ datos: res.data }))
            .catch(err => console.error("Error cargando datos", err));
    }

    cargarRelaciones = (tipo, id) => {
        if (!id) return;
        authAxios.get(`configuracion-educativa/relaciones/${tipo}/${id}`)
            .then(res => {
                this.setState(prevState => ({
                    relaciones: {
                        ...prevState.relaciones,
                        [tipo]: res.data
                    }
                }));
            });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            seleccion: { ...prevState.seleccion, [name]: value }
        }), () => {
            if (name === 'curso') this.cargarRelaciones('materias_curso', value);
            if (name === 'materia') this.cargarRelaciones('contenidos_materia', value);
            if (name === 'grupo') this.cargarRelaciones('estudiantes_grupo', value);
        });
    }

    handleAsignacionChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            asignacion: { ...prevState.asignacion, [name]: value }
        }));
    }

    asignar = (endpoint, payload, relacionKey, idKey) => {
        if (!payload[idKey]) {
            Swal.fire('Atención', 'Seleccione un elemento para asignar', 'warning');
            return;
        }

        authAxios.post(`configuracion-educativa/${endpoint}`, payload)
            .then(res => {
                if (res.data.Status) {
                    Swal.fire('Éxito', res.data.msj, 'success');
                    this.cargarRelaciones(relacionKey, payload[endpoint.includes('materia') ? 'curso_id' : endpoint.includes('contenido') ? 'materia_id' : 'grupo_id']);
                } else {
                    Swal.fire('Error', res.data.msj, 'error');
                }
            })
            .catch(err => Swal.fire('Error', 'No se pudo realizar la asignación', 'error'));
    }

    eliminar = (tipo, id, relacionKey, refreshId) => {
        Swal.fire({
            title: '¿Eliminar relación?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get(`configuracion-educativa/eliminar-relacion/${tipo}/${id}`)
                    .then(res => {
                        this.cargarRelaciones(relacionKey, refreshId);
                    });
            }
        });
    }

    render() {
        const { datos, seleccion, asignacion, relaciones, tab } = this.state;

        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card shadow-lg border-0" style={{ borderRadius: '20px' }}>
                        <div className="card-header bg-dark text-white py-3" style={{ borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                            <h3 className="mb-0 text-center fw-bold">Configuración Educativa</h3>
                        </div>
                        <div className="card-body">
                            {/* Nav Tabs */}
                            <ul className="nav nav-pills nav-fill mb-4 p-1 bg-light rounded-pill shadow-sm">
                                <li className="nav-item">
                                    <button className={`nav-link rounded-pill ${tab === 'cursos' ? 'active shadow' : ''}`} onClick={() => this.setState({ tab: 'cursos' })}>
                                        <FontAwesomeIcon icon={faLayerGroup} className="me-2" /> Materias por Curso
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link rounded-pill ${tab === 'materias' ? 'active shadow' : ''}`} onClick={() => this.setState({ tab: 'materias' })}>
                                        <FontAwesomeIcon icon={faBook} className="me-2" /> Contenidos por Materia
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link rounded-pill ${tab === 'matriculas' ? 'active shadow' : ''}`} onClick={() => this.setState({ tab: 'matriculas' })}>
                                        <FontAwesomeIcon icon={faUsers} className="me-2" /> Estudiantes por Grupo
                                    </button>
                                </li>
                            </ul>

                            <hr />

                            {/* Section: Curso -> Materias */}
                            {tab === 'cursos' && (
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="p-4 border rounded bg-white shadow-sm h-100">
                                            <h5 className="fw-bold mb-3">Asignar Materia a Curso</h5>
                                            <div className="mb-3">
                                                <label className="small fw-bold">1. Seleccione Curso</label>
                                                <select className="form-select" name="curso" value={seleccion.curso} onChange={this.handleChange}>
                                                    <option value="">-- Seleccionar Curso --</option>
                                                    {datos.cursos.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="small fw-bold">2. Seleccione Materia</label>
                                                <select className="form-select" name="materia_id" value={asignacion.materia_id} onChange={this.handleAsignacionChange}>
                                                    <option value="">-- Seleccionar Materia --</option>
                                                    {datos.materias.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                                                </select>
                                            </div>
                                            <button className="btn btn-primary w-100 shadow-sm" onClick={() => this.asignar('asignar-materia', { curso_id: seleccion.curso, materia_id: asignacion.materia_id }, 'materias_curso', 'materia_id')}>
                                                <FontAwesomeIcon icon={faPlus} className="me-2" /> Agregar Materia al Curso
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="p-4 border rounded bg-white shadow-sm h-100">
                                            <h5 className="fw-bold mb-3">Materias Asignadas</h5>
                                            {seleccion.curso ? (
                                                <ul className="list-group list-group-flush">
                                                    {relaciones.materias_curso.length > 0 ? (
                                                        relaciones.materias_curso.map(m => (
                                                            <li key={m.id} className="list-group-item d-flex justify-content-between align-items-center">
                                                                <span>{m.nombre}</span>
                                                                <button className="btn btn-outline-danger btn-sm border-0" onClick={() => this.eliminar('materia', m.id, 'materias_curso', seleccion.curso)}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                            </li>
                                                        ))
                                                    ) : <li className="list-group-item text-muted small">No hay materias asignadas</li>}
                                                </ul>
                                            ) : <div className="text-center py-5 text-muted small">Seleccione un curso para ver sus materias</div>}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Section: Materia -> Contenidos */}
                            {tab === 'materias' && (
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="p-4 border rounded bg-white shadow-sm h-100">
                                            <h5 className="fw-bold mb-3">Asignar Contenido a Materia</h5>
                                            <div className="mb-3">
                                                <label className="small fw-bold">1. Seleccione Materia</label>
                                                <select className="form-select" name="materia" value={seleccion.materia} onChange={this.handleChange}>
                                                    <option value="">-- Seleccionar Materia --</option>
                                                    {datos.materias.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="small fw-bold">2. Seleccione Contenido</label>
                                                <select className="form-select" name="contenido_id" value={asignacion.contenido_id} onChange={this.handleAsignacionChange}>
                                                    <option value="">-- Seleccionar Contenido --</option>
                                                    {datos.contenidos.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                                                </select>
                                            </div>
                                            <button className="btn btn-success w-100 shadow-sm" onClick={() => this.asignar('asignar-contenido', { materia_id: seleccion.materia, contenido_id: asignacion.contenido_id }, 'contenidos_materia', 'contenido_id')}>
                                                <FontAwesomeIcon icon={faPlus} className="me-2" /> Agregar Contenido a la Materia
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="p-4 border rounded bg-white shadow-sm h-100">
                                            <h5 className="fw-bold mb-3">Contenidos Asignados</h5>
                                            {seleccion.materia ? (
                                                <ul className="list-group list-group-flush">
                                                    {relaciones.contenidos_materia.length > 0 ? (
                                                        relaciones.contenidos_materia.map(c => (
                                                            <li key={c.id} className="list-group-item d-flex justify-content-between align-items-center">
                                                                <span className="small">{c.nombre}</span>
                                                                <button className="btn btn-outline-danger btn-sm border-0" onClick={() => this.eliminar('contenido', c.id, 'contenidos_materia', seleccion.materia)}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                            </li>
                                                        ))
                                                    ) : <li className="list-group-item text-muted small">No hay contenidos asignados</li>}
                                                </ul>
                                            ) : <div className="text-center py-5 text-muted small">Seleccione una materia para ver sus contenidos</div>}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Section: Grupo -> Estudiantes */}
                            {tab === 'matriculas' && (
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="p-4 border rounded bg-white shadow-sm h-100">
                                            <h5 className="fw-bold mb-3">Matricular Estudiante en Grupo</h5>
                                            <div className="mb-3">
                                                <label className="small fw-bold">1. Seleccione Grupo</label>
                                                <select className="form-select" name="grupo" value={seleccion.grupo} onChange={this.handleChange}>
                                                    <option value="">-- Seleccionar Grupo --</option>
                                                    {datos.grupos.map(g => <option key={g.id} value={g.id}>{g.nombre}</option>)}
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="small fw-bold">2. Seleccione Estudiante</label>
                                                <select className="form-select" name="estudiante_id" value={asignacion.estudiante_id} onChange={this.handleAsignacionChange}>
                                                    <option value="">-- Seleccionar Estudiante --</option>
                                                    {datos.estudiantes.map(e => <option key={e.id} value={e.id}>{e.nombre} - {e.numero_documento}</option>)}
                                                </select>
                                            </div>
                                            <button className="btn btn-info w-100 shadow-sm text-white" onClick={() => this.asignar('matricular-estudiante', { grupo_id: seleccion.grupo, estudiante_id: asignacion.estudiante_id }, 'estudiantes_grupo', 'estudiante_id')}>
                                                <FontAwesomeIcon icon={faPlus} className="me-2" /> Matricular Estudiante
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="p-4 border rounded bg-white shadow-sm h-100">
                                            <h5 className="fw-bold mb-3">Estudiantes Matriculados</h5>
                                            {seleccion.grupo ? (
                                                <ul className="list-group list-group-flush">
                                                    {relaciones.estudiantes_grupo.length > 0 ? (
                                                        relaciones.estudiantes_grupo.map(e => (
                                                            <li key={e.id} className="list-group-item d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <div className="fw-bold">{e.nombre}</div>
                                                                    <div className="extra-small text-muted">{e.numero_documento}</div>
                                                                </div>
                                                                <button className="btn btn-outline-danger btn-sm border-0" onClick={() => this.eliminar('matricula', e.id, 'estudiantes_grupo', seleccion.grupo)}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                            </li>
                                                        ))
                                                    ) : <li className="list-group-item text-muted small">No hay estudiantes matriculados</li>}
                                                </ul>
                                            ) : <div className="text-center py-5 text-muted small">Seleccione un grupo para ver sus estudiantes</div>}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="card-footer text-center py-3 bg-light" style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                            <span className="small text-muted">AOA Edu System - Módulo de Configuración</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfiguracionCursos;